import React from 'react';
import { func, bool } from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import Modal from '../../../shared/Modal';
import RoundedButton from '../../../shared/Buttons/RoundedButton';
import COPY from '../../../../utils/copy';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
  },
  title: {
    lineHeight: '32.4px',
  },
  subtitle: {
    color: theme.palette.secondary.main,
  },
  body: {
    fontWeight: 400,
    lineHeight: '22.5px',
  },
  list: {
    listStyle: 'circle !important',
  },
}));

const PrivacyModal = ({ active, onClose }) => {
  const classes = useStyles();

  return (
    <Modal
      active={active}
      onClose={onClose}
      aria-labelledby="privacy-modal"
      aria-describedby="modal to provide information for privacy."
    >
      <Box
        classes={{ root: classes.root }}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        mx="auto"
        px={{ xs: 2 }}
        pb={{ xs: 2 }}
        pt={{ xs: 0 }}
        textAlign="center"
      >
        <Box display="flex" justifyContent="center" pt={1}>
          <Typography variant="h6" classes={{ root: classes.subtitle }}>
            MUST READ!
          </Typography>
        </Box>
        <Box pb={4} display="flex" justifyContent="center">
          <Typography variant="h3" classes={{ root: classes.title }}>
            California and Illinois leads
          </Typography>
        </Box>
        <Box pb={5} display="flex" alignSelf="center" textAlign="center" width={340}>
          <Typography variant="body" classes={{ root: classes.body }}>
            {COPY.PRIVACY_MODAL_BODY}
          </Typography>
        </Box>
        <Box height="100%" display="flex" flexDirection="column" alignSelf="center" pb={2} width={160}>
          <RoundedButton onClick={onClose}>Proceed</RoundedButton>
        </Box>
      </Box>
    </Modal>
  );
};

PrivacyModal.propTypes = {
  active: bool.isRequired,
  onClose: func.isRequired,
};

export default PrivacyModal;
